import { get } from 'lodash';
/**
 * Helper functions for state management using local storage
 */
export default {
  getFromLocal(key) {
    const stateFromLocal = JSON.parse(localStorage.getItem('vuex'));
    return get(stateFromLocal, key, null);
  },
  setOnLocal(key, value) {
    const stateFromLocal = JSON.parse(localStorage.getItem('vuex'));
    stateFromLocal[key] = value;
    localStorage.setItem('vuex', stateFromLocal);
  },
  removeOnLocal(key) {
    localStorage.removeItem(key);
  },
  clearLocal() {
    localStorage.clear();
  },
};
